import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { Button, FormControl, FormControlLabel, InputAdornment, OutlinedInput, Radio, RadioGroup, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import RangeSlider from 'src/components/property/RangeSlider';
import HelpCenterButton from 'src/components/shared/HelpCenterButton';
import { VACANT_UNIT_USAGE } from 'src/constants/utilities';
import { useStore } from 'src/stores';
import useModalFooterStyles from 'src/styles/cutomModalFooter';
import useStyles from './styles';
import { VacantUnitOccupantsSelector } from 'src/components/property/VacantUnitOccupantsSelector';

/** Backend may send 0.55 (decimal) or 55 (percentage). Returns integer 0–100 for UI. */
function toPercentageValue(value) {
  if (value == null || value === '') return null;
  const n = Number(value);
  if (Number.isNaN(n)) return null;
  return n <= 1 && n > 0 ? Math.round(n * 100) : Math.round(n);
}
const VacantUnitBillsContent = observer(_ref => {
  var _store$homeDashboardS, _ref2;
  let handleSave = _ref.handleSave,
    propertyUtility = _ref.propertyUtility;
  const classes = useStyles();
  const modalFooterClasses = useModalFooterStyles();
  const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;

  // const setVacantUnitUsage = store.addNewProperty.setVacantUnitUsage;
  // const setVacantUnitUsageLimit = store.addNewProperty.setVacantUnitUsageLimit;
  const _useState = useState(
    // store.addNewProperty.vacantUnitUsage.get(utility.utilityId) ||
    propertyUtility.vacantUnitUsage ||
    // utility.defaultVacantUnitUsage ||
    VACANT_UNIT_USAGE.NoUsage),
    _useState2 = _slicedToArray(_useState, 2),
    vacantUnitUsage = _useState2[0],
    setVacantUnitUsage = _useState2[1];
  const defaultValue = ((_store$homeDashboardS = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS === void 0 || (_store$homeDashboardS = _store$homeDashboardS.getUtilityInfoById(propertyUtility === null || propertyUtility === void 0 ? void 0 : propertyUtility.utilityId)) === null || _store$homeDashboardS === void 0 ? void 0 : _store$homeDashboardS.defaultVacantUnitUsage) === VACANT_UNIT_USAGE.LimitedUsage ? 30 : 10;
  const rawLimit = propertyUtility.vacantUnitUsageLimit;
  // Until the PM moves the slider the limit follows the current default, so a default that lands while the
  // dialog is open is used; once they edit it, their value stays.
  const _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    editedLimit = _useState4[0],
    setEditedLimit = _useState4[1];
  const vacantUnitUsageLimit = (_ref2 = editedLimit !== null && editedLimit !== void 0 ? editedLimit : toPercentageValue(rawLimit)) !== null && _ref2 !== void 0 ? _ref2 : defaultValue;
  const isDisabled = vacantUnitUsage !== VACANT_UNIT_USAGE.LimitedUsage;
  const _useState5 = useState(propertyUtility.vacantUnitOccupantsCount || 1),
    _useState6 = _slicedToArray(_useState5, 2),
    vacantUnitOccupantsCount = _useState6[0],
    setVacantUnitOccupantsCount = _useState6[1];
  const levels = [{
    key: VACANT_UNIT_USAGE.NormalUsage,
    label: t('add_new_property_flow.full_usage'),
    text: t('add_new_property_flow.full_usage_text')
  }, {
    hasInput: true,
    key: VACANT_UNIT_USAGE.LimitedUsage,
    label: t('add_new_property_flow.unit_usage_limited_usage'),
    text: t('add_new_property_flow.limited_usage_text')
  }, {
    key: VACANT_UNIT_USAGE.NoUsage,
    label: t('add_new_property_flow.no_usage'),
    text: t('add_new_property_flow.no_usage_text')
  }];
  const handleChange = (event, value) => setEditedLimit(value);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, t('add_new_property_flow.level_of_usage')), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, t('add_new_property_flow.level_of_usage_text')), /*#__PURE__*/React.createElement("div", {
    className: classes.mdSection
  }, /*#__PURE__*/React.createElement(RadioGroup, {
    onChange: e => {
      setVacantUnitUsage(e.target.value);
    },
    value: vacantUnitUsage
  }, levels.map(level => /*#__PURE__*/React.createElement("div", {
    onClick: () => setVacantUnitUsage(level.key)
  }, /*#__PURE__*/React.createElement(FormControlLabel, {
    control: /*#__PURE__*/React.createElement(Radio, {
      value: level.key
    }),
    key: level.key,
    label: /*#__PURE__*/React.createElement(Typography, {
      variant: "h4"
    }, level.label),
    value: level.key
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.item
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, level.text), level.key === VACANT_UNIT_USAGE.NormalUsage && /*#__PURE__*/React.createElement(VacantUnitOccupantsSelector, {
    allocationMethod: propertyUtility.allocationMethod,
    onChange: setVacantUnitOccupantsCount,
    vacantUnitUsage: vacantUnitUsage,
    value: vacantUnitOccupantsCount
  }), level.hasInput && /*#__PURE__*/React.createElement("div", {
    className: classes.sliderWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.slider
  }, /*#__PURE__*/React.createElement(RangeSlider, {
    isDisabled: isDisabled,
    labelFormat: "percentage",
    handleChange: handleChange,
    maxValue: 90,
    minValue: 10,
    stepValue: 5,
    value: vacantUnitUsageLimit
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.input
  }, /*#__PURE__*/React.createElement(FormControl, {
    variant: "outlined"
  }, /*#__PURE__*/React.createElement(OutlinedInput, {
    disabled: true,
    endAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
      position: "end"
    }, "%"),
    id: "vacantUnitUsageLimit",
    type: "number",
    value: vacantUnitUsageLimit
  })))))))))), /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, /*#__PURE__*/React.createElement(HelpCenterButton, {
    topic: "vacant unit bills"
  })), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.footerButton, " ").concat(modalFooterClasses.modalFooter)
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: event => {
      event.stopPropagation();
      event.preventDefault();
      handleSave({
        vacantUnitUsage,
        vacantUnitUsageLimit,
        vacantUnitOccupantsCount
      });
    },
    variant: "contained",
    'custom-attribute': '645-new-billing-module'
  }, t('add_new_property_flow.save_and_close'))));
});
export default VacantUnitBillsContent;